import { useState, useEffect, useCallback } from "react";
import { useAuthContext } from "./../../Context/AuthContext";
import { useLanguageContext } from "./../../Context/LanguageContext";
import usermanagementsActions from "./../../Actions/UserManagementActions";
import usermanagementsConstants from "./../../Constants/UsermanagementConstants";
import usermanagementStore from "./../../Stores/UsermanagementStore";
import Paginator from "../Pagging/Paginator";

const initSort = {
  key: "username",
  order: "asc",
  className: "glyphicon glyphicon-sort-by-alphabet",
};

function Benutzerverwaltung() {
  const isAuthenticated = useAuthContext();
  const { translate } = useLanguageContext();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(1000);
  const [pageCount, setPageCount] = useState(null);
  const [rowCount, setRowCount] = useState(null);
  const [firstRowOnPage, setFirstRowOnPage] = useState(null);
  const [lastRowOnPage, setLastRowOnPage] = useState(null);

  const [data, setData] = useState(null);
  const [renderMe, setRenderMe] = useState(null);
  const [searchQ, setSearchQ] = useState(null);

  const [sortBy, setSortBy] = useState(initSort);

  const updateSearchQuery = (e) => {
    setSearchQ(e.target.value);
  };

  const fetchData = useCallback(() => {
    if (isAuthenticated) {
      if (searchQ !== null && searchQ !== undefined) {
        usermanagementsActions.getUsers(
          sessionStorage.getItem("userid"),
          currentPage,
          pageSize,
          searchQ,
        );
      } else {
        usermanagementsActions.getUsers(
          sessionStorage.getItem("userid"),
          currentPage,
          pageSize,
        );
      }
    }
  }, [currentPage, pageSize, searchQ]);

  useEffect(() => {
    fetchData();
    return () => {};
  }, [fetchData]);

  useEffect(() => {
    function updateData() {
      var res = usermanagementStore.getResult();
      setData(res);
    }

    usermanagementStore.addChangeListener(
      usermanagementsConstants.GET_USERS_SUCESS,
      updateData,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        usermanagementsConstants.GET_USERS_SUCESS,
        updateData,
      );
    };
  }, []);

  useEffect(() => {
    function updateData() {
      var res = usermanagementStore.getResult();
      setData(res);
    }

    usermanagementStore.addChangeListener(
      usermanagementsConstants.GET_USERS_FAILURE,
      updateData,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        usermanagementsConstants.GET_USERS_FAILURE,
        updateData,
      );
    };
  }, []);

  useEffect(() => {
    let _renderMe = null;

    if (data !== null && data !== undefined) {
      var keys = Object.keys(data.results[0]);
      _renderMe = data.results.map((row, index) => {
        return (
          <tr key={index}>
            <RenderUserRow key={index} data={row} keys={keys} />
          </tr>
        );
      });

      setPageCount(data.pageCount);
      setRowCount(data.rowCount);
      setFirstRowOnPage(data.firstRowOnPage);
      setLastRowOnPage(data.lastRowOnPage);
    }
    setRenderMe(_renderMe);
  }, [data]);

  return (
    <div className="container-fluid" id="content">
      <div>
        <h3 className="page-header" style={{ fontWeight: "bold" }}>
          Benutzerverwaltung
        </h3>
      </div>
      <div className="row">
        <div className="col-3">
          <form>
            <div className="form-group has-search">
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                style={{
                  borderBottom: "solid #00677f",
                  borderRadius: "0px",
                  height: "40px",
                }}
                value={searchQ}
                onChange={updateSearchQuery}
              />
            </div>
          </form>
        </div>
        <div className="col-9 searchbtn-container">
          <div className="form-group" style={{ marginRight: "15px" }}>
            <button
              type="button"
              className="btn btn-primary"
              aria-label="Right Align"
              style={{ borderRadius: "5px" }}
            >
              <span
                className="glyphicon glyphicon-plus"
                aria-hidden="false"
              ></span>
            </button>
          </div>
        </div>
      </div>
      <div className="table-responsive table-height text-center">
        <table className="table table-striped table-hover table-sticky">
          <thead>
            <tr>
              <th>
                {translate.usermanagement.werk}
                <span
                  className={sortBy.key === "werk" ? sortBy.className : ""}
                ></span>{" "}
              </th>
              <th>{translate.usermanagement.vorname}</th>
              <th>{translate.usermanagement.nachname}</th>
              <th>{translate.usermanagement.username}</th>
              <th>{translate.usermanagement.personalnr}</th>
              <th>{translate.usermanagement.aktiv}</th>
              <th>{translate.usermanagement.extern}</th>
            </tr>
          </thead>
          <tbody>{renderMe}</tbody>
        </table>
      </div>
      <Paginator
        pageCount={pageCount}
        activePage={currentPage}
        setCurrentPage={setCurrentPage}
        rowCount={rowCount}
        pageSize={pageSize}
        setPageSize={setPageSize}
        firstRowOnPage={firstRowOnPage}
        lastRowOnPage={lastRowOnPage}
      />
    </div>
  );
}

const RenderUserRow = ({ data, keys }) => {
  return keys.map((key, index) => {
    if (key.toLowerCase() === "id") return;
    if (key.toLowerCase().includes("passwor")) return;
    if (key.toLowerCase() === "aktiv" || key.toLowerCase() === "isextern") {
      return (
        <td key={index}>
          <input
            type="checkbox"
            name={key}
            checked={data[key]}
            key={key + " _" + index}
          />
        </td>
      );
    }

    return (
      <td key={index} id={key + " " + index}>
        {data[key]}
      </td>
    );
  });
};
export default Benutzerverwaltung;
